import Phaser from "phaser";
import type { SpellDefinition } from "./SpellDefinitions";

export class PlayerProjectile extends Phaser.Physics.Arcade.Image {
  readonly spell: SpellDefinition;
  private remainingLifeMs = 1500;
  private alreadyHit = false;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    angle: number,
    spell: SpellDefinition,
  ) {
    super(scene, x, y, "boss-projectile");

    this.spell = spell;
    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.setScale(spell.id === "ice-spike" ? 0.34 : 0.42);
    this.setTint(spell.tint);
    this.setBlendMode(Phaser.BlendModes.ADD);
    this.setDepth(Math.round(y) + 20);
    this.setRotation(angle);

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setCircle(18);
    body.setVelocity(Math.cos(angle) * spell.speed, Math.sin(angle) * spell.speed);
  }

  override update(delta: number): void {
    this.remainingLifeMs -= delta;
    this.setDepth(Math.round(this.y) + 20);
    if (this.remainingLifeMs <= 0) this.destroy();
  }

  consume(): boolean {
    if (this.alreadyHit) return false;
    this.alreadyHit = true;
    this.destroy();
    return true;
  }
}
